module.exports = __webpack_public_path__ + "bf2532df/img/projectsBack.88f3b3a9.png";